Namespace('Settings.Views.ChatbotConfiguration')

class Settings.Views.ChatbotConfiguration.ChatbotConfigurationView extends Backbone.View
  template: JST['backbone/templates/settings/chatbot_configuration/chatbot_configuration']
  className: 'chatbot-configuration'

  initialize: ({username, chatbots}) ->
    @username = username
    @chatbots = chatbots
    @intentsCollection = new Settings.ChatbotConfiguration.IntentCollection
    @chatbotsSelectView = new Settings.Views.ChatbotConfiguration.ChatbotsSelectView(@chatbots)
    @intentsTableView = new Settings.Views.ChatbotConfiguration.IntentsTableView(@intentsCollection, @username)
    @fetchIntents()

    @listenTo(@chatbotsSelectView, 'change', @fetchIntents)
    @listenTo(@intentsTableView, 'intent:updated', @submitIntents)

    @listenTo(@intentsCollection, 'intents:fetch:error', @handleFetchResponseError)
    @listenTo(@intentsCollection, 'intents:save:error', @handleSaveResponseError)

  render: =>
    @$el.html(@template())

    @$el.find('#chatbots-select').html(@chatbotsSelectView.render().el)
    if @chatbots.length > 0
      @$el.find('#intents-table').html(@intentsTableView.render().el)
      @hideTable()
    else
      @missingChatbotsView = new Settings.Views.ChatbotConfiguration.MissingChatbotsView()
      @$el.find('#missing-chatbots').html(@missingChatbotsView.render().el)
    @

  fetchIntents: =>
    if @chatbotsSelectView.isChatbotSelected()
      @intentsCollection.fetchFor(@selectedChatbotCode())
      @showTable()
      @intentsTableView.displayPlaceholder()
    else
      @hideTable()

  submitIntents: =>
    @intentsCollection.saveFor(@selectedChatbotCode())

  selectedChatbotCode: =>
    @chatbotsSelectView.chatbotCode

  currentIntents: =>
    @intentsCollection.models

  hideTable: =>
    @$el.find('#intents-table').css('display', 'none')

  showTable: =>
    @$el.find('#intents-table').css('display', 'block')

  handleFetchResponseError: (response) ->
    @hideTable()
    window.showError(response.error)

  handleSaveResponseError: (response) ->
    window.showError(response.error)
